import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-element"
export default class extends Controller {
  static classes = ['hide', 'show']
  static targets = ['parent', 'child']
  // data-toggle-element-triggers-value='["some", "values"]'
  static values = {
    triggers: { type: Array, default: [] }
  }

  connect() {
    if (!this.hasTriggersValue) {
      console.warn("No trigger values found")
    } else {
      this.triggersValue = this.triggersValue.map(element => element.toLowerCase())
    }
    this.toggle();
  }

  toggle() {
    let selectedValue = String(this.parentTargets.at(-1).value).toLowerCase()
    if (this.triggersValue.includes(selectedValue)) {
      this.childTarget.classList.remove(this.hideClass)
      this.childTarget.classList.add(this.showClass)
    } else {
      this.childTarget.classList.add(this.hideClass)
      this.childTarget.classList.remove(this.showClass)
    }
  }
}
